
import React from "react";
import { Badge } from "@/components/ui/badge";

interface SmsStatusBadgeProps {
  status: string;
}

const SmsStatusBadge: React.FC<SmsStatusBadgeProps> = ({ status }) => {
  if (status === "sent")
    return (
      <Badge className="bg-emerald-100 text-emerald-700 border-emerald-200 hover:bg-emerald-100">
        Εστάλη
      </Badge>
    );
  if (status === "delivered")
    return (
      <Badge className="bg-blue-100 text-blue-700 border-blue-200 hover:bg-blue-100">
        Παραδόθηκε
      </Badge>
    );
  if (status === "failed")
    return <Badge variant="destructive">Αποτυχία</Badge>;
  return <Badge variant="outline">{status}</Badge>;
};

export default SmsStatusBadge;
